var React = require('react');

function Bed (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M19,2H5C2.243,2,0,4.243,0,7v14c0,.553,.448,1,1,1s1-.447,1-1v-2H22v2c0,.553,.447,1,1,1s1-.447,1-1V7c0-2.757-2.243-5-5-5ZM5,4h14c1.654,0,3,1.346,3,3v6h-2c0-2.206-1.794-4-4-4h-1c-1.194,0-2.266,.526-3,1.357-.734-.832-1.806-1.357-3-1.357h-1c-2.206,0-4,1.794-4,4H2V7c0-1.654,1.346-3,3-3ZM13,13c0-1.103,.897-2,2-2h1c1.103,0,2,.897,2,2h-5Zm-7,0c0-1.103,.897-2,2-2h1c1.103,0,2,.897,2,2H6Zm-4,4v-2H22v2H2Z"}));
}

Bed.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 24 24","fill":"#FFFFFF"};

module.exports = Bed;

Bed.default = Bed;
